module.exports = __webpack_public_path__ + "img/collection-weddingRingsGold@2x.04f0b2f.webp";